module.exports = __webpack_public_path__ + "img/house.f3b73beb.svg";